import { setIsStarting } from '../Actions/status';
import setupSentry from '../Services/setupSentry';
import setupAxios from '../Services/setupAxios';
import { loadCurrentUser } from '../Services/userAuth';

export default () => async (dispatch, getState) => {
  
  dispatch(setIsStarting(true));

  dispatch(setupSentry());

  dispatch(setupAxios());
  
  // Load current user and permissions if token exists
  const state = getState();
  if (state.token) {
    try {
      await dispatch(loadCurrentUser());
    } catch (error) {
      console.error('Failed to load user on startup:', error);
    }
  }
  
  setTimeout(() => dispatch(setIsStarting(false)), 1000);
  
}